import { Component} from '@angular/core';
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { getAuth} from '@angular/fire/auth';
import { FirebaseApp } from '@angular/fire/app';

import { StorageService } from 'src/app/services/common/storage';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/authservice/auth-service';
// import { LogIn } from 'src/app/store/actions/auth.actions';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  public showSpinner: boolean = false;
  public submitted: boolean = false;
  public submitFormName: string;
  public state: any;
  public message: string;
  public resetPassword: FormGroup;
  public error:string;

  constructor(public auth:AuthService,private afApp: FirebaseApp, protected localStorage: StorageService,
    private readonly router: Router,
    public storage: StorageService) {

    this.resetPassword = new FormGroup({
      email: new FormControl(
        '',
        [
          Validators.required,
          Validators.email,
        ])
    });

  }

  /**
   * Login  forStudent
   * 
   */
  onSubmit() {
    if (this.resetPassword.invalid) {
      return;
    }

    this.resetPasswordUser();
  }

  /**
   * 
   * @param auth 
   * @param email 
   * @param password 
   */
  private async resetPasswordUser() {
    this.showSpinner = true;
    const auth = getAuth(this.afApp);
      this.auth.resetPasswordInit(auth, this.resetPassword.value.email)
      .then(x=>{
        this.error = "";
        this.message = "Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail";
        this.showSpinner = false;
      },error=>{
        this.showSpinner = false;
        this.error = "Un problème technique s'est produit, veuillez contacter l'administrateur du site.";
        this.message = "";
      });
    
  }

}
